import('../../styles/invisible.less');
export var PLATFORM_KEYWORD = 'WECOM_ISV';
export var designate = function (injectPlatform) {
    if (injectPlatform === void 0) { injectPlatform = true; }
    window.isInWeComISV = true;
    injectPlatform && (window.__PLANTFORM__ = PLATFORM_KEYWORD);
};
